import { type IShape } from "../interfaces/shapes.interface";

type Id = string | number;
const keyOf = (id: Id) => String(id);

export function upsertManyById(target: IShape[], incoming: IShape[]) {
  const indexById = new Map<string, number>();
  target.forEach((s, i) => indexById.set(keyOf(s.id), i));

  for (const s of incoming) {
    const k = keyOf(s.id);
    const idx = indexById.get(k);
    if (idx === undefined) {
      indexById.set(k, target.length);
      target.push(s);
    } else {
      target[idx] = s;
    }
  }
}

export function removeById(target: IShape[], shapeId: string) {
  const k = keyOf(shapeId);
  for (let i = target.length - 1; i >= 0; i--) {
    if (keyOf(target[i].id) === k) target.splice(i, 1);
  }
}

export function upsertAtTop(target: IShape[], shape: IShape) {
  const k = keyOf(shape.id);
  const idx = target.findIndex((x) => keyOf(x.id) === k);
  if (idx === -1) target.unshift(shape);
  else target[idx] = shape;
}
